import { executeRequest, Request } from '@jfs/network'
import { APIEndPoints } from './APIEndpoints'
import { sitConfig } from './config'

const responseParser = async (data: any) => {
  return data
}

const downloadVoiceBoxInvoice: any = (tokens: any, req: any) => {
  const request: Request<{}> = {
    config: sitConfig(tokens),
    apiPath: `${APIEndPoints.downloadPdfInvoice}`,
    method: 'POST',
    cache: false,
    body: req,
  }
  return executeRequest(request).then((data: any) => {
    if (data?.data?.responseCode === '500') {
      throw [{ data: { message: data?.data?.status } }]
    } else {
      return responseParser(data)
    }
  })
}

export { downloadVoiceBoxInvoice }
